import { Copy, CopyCheckIcon } from 'lucide-react';
import { useState } from 'react';

const syntaxHighlight = (json: any) => {
  if (!json) return '';

  let jsonString = JSON.stringify(json, null, 2);

  jsonString = jsonString
    .replace(
      /\"([^"]+)\":/g,
      `<span class="text-cyan-400 terminalFont">"$1"</span>:`,
    )
    .replace(
      /: \"([^"]*)\"/g,
      `: <span class="text-green-400 terminalFont">"$1"</span>`,
    )
    .replace(
      /: ([0-9.]+)/g,
      `: <span class="text-orange-400 terminalFont">$1</span>`,
    )
    .replace(
      /: (true|false)/g,
      `: <span class="text-purple-400 terminalFont">$1</span>`,
    )
    .replace(/: null/g, `: <span class="text-gray-400">null</span>`);

  return jsonString;
};

const TerminalView = ({
  title = 'ERP Logs',
  content,
}: {
  title?: string;
  content: any;
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(JSON.stringify(content, null, 2));
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch (e) {
      console.error('Copy failed:', e);
    }
  };

  return (
    <div
      style={{ scrollbarWidth: 'thin' }}
      className="rounded-lg terminalFont overflow-y-scroll h-full shadow-xl border border-gray-700 bg-[#1a1a1a]"
    >
      <div className="flex items-center justify-between px-4 py-2 bg-[#1a1a1a] border-b border-gray-700">
        <div className="flex items-center gap-2">
          <span className="w-3 h-3 rounded-full bg-red-500"></span>
          <span className="w-3 h-3 rounded-full bg-yellow-400"></span>
          <span className="w-3 h-3 rounded-full bg-green-500"></span>

          <span className="text-gray-300 text-sm ml-4">{title}</span>
        </div>

        <button
          onClick={handleCopy}
          className="text-xs cursor-pointer px-3 py-1 rounded text-white transition"
        >
          {copied ? <CopyCheckIcon size={20} /> : <Copy size={20} />}
        </button>
      </div>
      <div className="p-4 font-mono text-[13px] h-full bg-[#1a1a1a]">
        <div className="text-green-500 mb-2">
          <span className="opacity-60">user@system</span>:
          <span className="text-blue-400">~/logs</span>$ cat erp.json
        </div>

        <pre
          className="whitespace-pre-wrap terminalFont leading-relaxed  bg-[#1a1a1a] tracking-wide"
          dangerouslySetInnerHTML={{
            __html: syntaxHighlight(content),
          }}
        />
      </div>
    </div>
  );
};

export default TerminalView;
